'use client'

import { useDatadogUser } from '@/lib/hooks/use-datadog'

/**
 * Attaches the signed-in identity to Datadog RUM + browser-logs.
 *
 * Must be mounted INSIDE `<ClerkProvider>` (it reads Clerk hooks), which is why
 * this is separate from `<DatadogInitializer />` — that one sits outside the
 * provider on purpose so RUM captures Clerk's own load failures. See the
 * `useDatadogUser` doc comment for the full reasoning.
 */
const DatadogUserContext = () => {
  useDatadogUser()
  return null
}

export default DatadogUserContext
